import tw from "tailwind-styled-components"

export const Spacer = tw.div`
h-6
w-10
`

export const TriggerWrapper = tw.div`
relative
flex
flex-col
flex-shrink-0
border-b
border-white/7
[content-visibility:auto]
[contain-intrinsic-block-size:auto_10vh]
`

export const RemoveButton = tw.button`
  absolute
  right-2
  top-2
`
